import { render, staticRenderFns } from "./CoeSelections.vue?vue&type=template&id=5a5afec0&"
import script from "./CoeSelections.vue?vue&type=script&lang=js&"
export * from "./CoeSelections.vue?vue&type=script&lang=js&"
import style0 from "./CoeSelections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/viniazvd/vue-coe-calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5afec0')) {
      api.createRecord('5a5afec0', component.options)
    } else {
      api.reload('5a5afec0', component.options)
    }
    module.hot.accept("./CoeSelections.vue?vue&type=template&id=5a5afec0&", function () {
      api.rerender('5a5afec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CoeSelections.vue"
export default component.exports